import React from 'react';
import { useTranslation } from 'react-i18next';

import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';

import { Dialog, IconButton, DialogTitle, Button } from '@material-ui/core';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';

import { CheckboxButtonsGroup, Input } from '../index';
import FormActionButtons from '../form-action-buttons/FormActionButtons';
import validate from './validate';

import useStyles from './styles';

const initialValues = {
  firstName: '',
  lastName: '',
  phoneNumber: '',
  companyName: '',
  referencePrefix: '',
  email: '',
  isNotify: ''
};

const UserForm = props => {
  const { handleSubmit, open, onClose, isUpdate } = props;

  const classes = useStyles();
  const [t] = useTranslation();

  return (
    <Dialog open={open} classes={{ paper: classes.paper }}>
      <IconButton className={classes.closeBtn} onClick={onClose}>
        <HighlightOffIcon className={classes.closeIcon} />
      </IconButton>
      <DialogTitle
        id="alert-dialog-title"
        classes={{ root: classes.title }}
        disableTypography={true}
      >
        {t('User')}
      </DialogTitle>
      <div className={classes.formWrapper}>
        <form onSubmit={handleSubmit}>
          <div className={classes.inlineInputs}>
            <Field
              className={classes.input}
              name="firstName"
              label="First name *"
              placeholder="First name"
              component={Input}
            />
            <Field
              name="lastName"
              label="Last name *"
              className={classes.input}
              placeholder="Last name"
              component={Input}
            />
          </div>
          <div className={classes.inlineInputs}>
            <Field
              className={classes.input}
              name="email"
              disabled={!!isUpdate}
              label="Email *"
              placeholder="Email"
              component={Input}
            />
            <Field
              name="phoneNumber"
              label="Phone *"
              className={classes.input}
              isOnlyNumber={true}
              isPhoneNumber={true}
              maxLength={20}
              placeholder="Phone"
              component={Input}
            />
          </div>
          <div className={classes.inlineInputs}>
            <Field
              name="isNotify"
              className={classes.checkbox}
              component={CheckboxButtonsGroup}
            />
            </div>
          <div className={classes.actionsBtns}>
            <FormActionButtons
              cancelPath="/users"
              cancelCallback={onClose}
              actionLabel={isUpdate ? 'Save' : 'Create'}
            />
          </div>
        </form>
      </div>
    </Dialog>
  );
};

export default reduxForm({
  form: 'usersForm',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  touchOnBlur: false,
  initialValues,
  validate
})(connect(null)(UserForm));
